import { useSelector } from 'react-redux';
import { selectSelectedItem } from '@reducers/machines';
import { selectSingleBatchData } from '@reducers/batch';
import { Machine } from '@interfaces/machines';
import { ProductionBatchStatistics } from '@interfaces/search';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';

export const useBatchLoaded = (): boolean => {
  const selectedMachine: Machine = useSelector(selectSelectedItem);
  const batchState: ReducerEntityWithLoadingState<ProductionBatchStatistics | null> = useSelector(selectSingleBatchData);
  return selectedMachine?.machineStatus?.productionBatchId != null && batchState.wasLoaded && batchState.data != null;
};
